/**
 * 関連会社一覧 アウトプットVO
 */
export class KYMW9010OutputModel {
    public associatedCompanyId: string = <string>'';        // 関連会社ID
    public associatedCompanyName: string = <string>'';      // 関連会社名
}